<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import type { LoadListTableRow } from "../../../../_shared/_logic/load-list-row-model"
  import { rowHints } from "../../../../_shared/_logic/row-hints"

  const { row }: { row: LoadListTableRow } = $props()
  const hint = $derived(rowHints(row))
</script>

<span class="row-hint">
<StatusTag
    size="sm"
    label={hint.label}
    color={hint.color}
    textColor="var(--text-100)"
    tooltipContent={[
      ...hint.errors,
      ...hint.warnings,
      "Details zur Zeile über das Drei-Punkte-Menü öffnen.",
    ].join(" ")}
    disableTitle={true}
  />
</span>

<style>
  .row-hint {
    display: inline-flex;
  }
  .row-hint :global(.status-tag--neutral) {
    color: var(--text-100);
    border-color: var(--text-100);
  }
</style>
